import TileLayer from "ol/layer/Tile";
import {ImageArcGISRest, ImageWMS, TileArcGISRest, TileWMS} from "ol/source";
import {transformExtent, transform, get as getProjection} from "ol/proj";
import {callService} from "@/helpers/ol/ol-http-helper";
import ImageLayer from "ol/layer/Image";
import {
    getActiveLayers,
    getLayerAttributes,
    getLayerNamePrefix,
    removeLoaderByBookmarkPresentationID
} from "@/helpers/ol/ol-layer-helper";
import {Point} from "ol/geom";
import {getOlRotation} from "@/helpers/ol/ol-rotation-helper";
import {getToken} from "@/helpers/auth/auth-helper";
import * as TileState from "ol/TileState";
import {hideElementsBySelector} from "@/helpers/element-helper";

import {
    getLatLonProjectionName, getViewProjection,
    getViewProjectionByName,
    getViewProjectionName
} from "@/helpers/ol/ol-projection-helper";
import {scaleToResolution} from "@/helpers/ol/view/ol-view-resolutation-helper.js";

let token
/**
 * Add Web Map Service
 * @param map
 * @param service
 */
export function addServiceArcGisMapServer(map, service) {

    let serviceUrl = service.Url + '/' + service.Layer + '/MapServer'

    // console.log(service)

    let source = {
        url: serviceUrl,
        attributions: getLayerAttributes(service)
    }

    // console.log(serviceUrl)

    let layer
    // Set source
    if(service.Untiled) {
        source = new ImageArcGISRest(source)
    } else {
        source = new TileArcGISRest(source)
    }

    source.set('olcs_projection', getProjection('EPSG:3857'));

    const layerOptions = {
        minResolution: scaleToResolution(service.MinResolution),
        maxResolution: scaleToResolution(service.MaxResolution),
        name: getLayerNamePrefix() + service.id,
        opacity: service.Opacity / 10,
        zIndex: service.zIndex,
        source: source
    }

    // Set layer
    if(service.Untiled) {
        layer = new ImageLayer(layerOptions)
    } else {
        layer = new TileLayer(layerOptions)
    }

    map.addLayer(layer)

    removeLoaderByBookmarkPresentationID(service.id)

    return layer
}
